import { Workspace } from "./Workspace.js";
import { Login } from "./screens/Login.js";
import { useI18n } from "./i18n.js";
import { useSession } from "./session.js";

/**
 * Le tre schermate che esistono oggi.
 *
 * Non c'e' ancora un router: la navigazione fra le schede sta in
 * `Workspace`. Servira' con FocusMode, che deve essere indirizzabile — una
 * postazione lasciata su un impianto deve ritrovarlo dopo un ricaricamento
 * della pagina, non tornare alla griglia.
 */
export function App() {
  const { phase } = useSession();
  const { t } = useI18n();

  switch (phase.kind) {
    case "loading":
      // Un attimo di attesa, non una schermata di login lampeggiante: senza,
      // ogni ricaricamento mostra il login per un istante anche a chi e' gia'
      // dentro.
      return <div className="boot">{t("login.loggingIn")}</div>;
    case "bootstrap":
      return <Login mode="bootstrap" />;
    case "anonymous":
      return <Login mode="login" />;
    case "authenticated":
      return <Workspace />;
  }
}
